import Scriba from 'react-scriba';

export class DataDroit {
    static _chargementDroit() {
        let objet = { }
        var url = "api/Liste/ListeDesDroits";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementTypeMandat() {
        let objet = {}
        var url = "api/Liste/ListeDesTypeMandat";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementTypeMandatDroit(objet) {
        var url = "api/Liste/ListeDesTypeMandatDroit";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _enregistrementTypeMandatDroit(objet) {
        var url = "api/MAJDonnees/EnregistrementTypeMandatDroit";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _suppressionTypeMandatDroit(objet) {
        var url = "api/MAJDonnees/SuppressionTypeMandatDroit";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }
};